import { Box, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../theme/tokens";

const ThemedDataGrid = ({
  rows,
  columns,
  height = "75vh",
  width = "100%",
  sx = {},
  ...props
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box
      height={height}
      width={width}
      sx={{
        border: `1px solid ${colors.surface.border}`,
        borderRadius: theme.shape.radius?.md || 2,
        overflow: "hidden",
        bgcolor: colors.surface.card,

        "& .MuiDataGrid-root": {
          border: "none",
          color: colors.text.secondary,
          backgroundColor: colors.surface.card,
        },

        "& .MuiDataGrid-cell": {
          borderBottom: `1px solid ${colors.surface.border}`,
        },

        "& .MuiDataGrid-columnHeaders, & .MuiDataGrid-columnHeader": {
          backgroundColor: `${colors.surface.header} !important`,
          color: `${colors.text.secondary} !important`,
          borderBottom: `1px solid ${colors.surface.border}`,
        },

        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: 700,
          color: `${colors.text.secondary} !important`,
        },

        "& .MuiDataGrid-columnSeparator": {
          color: colors.surface.border,
        },

        "& .MuiDataGrid-footerContainer": {
          borderTop: `1px solid ${colors.surface.border}`,
          backgroundColor: `${colors.surface.footer} !important`,
          color: `${colors.text.secondary} !important`,
        },

        "& .MuiTablePagination-root, & .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
          color: `${colors.text.secondary} !important`,
        },

        "& .MuiTablePagination-actions button": {
          color: `${colors.text.secondary} !important`,
        },

        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: colors.surface.card,
        },

        "& .MuiDataGrid-row": {
          backgroundColor: colors.surface.card,
        },

        "& .MuiDataGrid-row:hover": {
          backgroundColor: `${colors.surface.hover} !important`,
        },

        "& .MuiDataGrid-row.Mui-selected": {
          backgroundColor: `${colors.scalpelTeal[900]} !important`,
        },

        "& .MuiDataGrid-row.Mui-selected:hover": {
          backgroundColor: `${colors.scalpelTeal[800]} !important`,
        },

        "& .MuiDataGrid-footerContainer": {
          borderTop: `1px solid ${colors.surface.border}`,
          backgroundColor: colors.background.default,
          color: colors.text.secondary,
        },

        "& .MuiTablePagination-root": {
          color: colors.text.secondary,
        },

        "& .MuiCheckbox-root": {
          color: colors.scalpelTeal[400],
        },

        "& .MuiDataGrid-menuIcon button, & .MuiDataGrid-sortIcon": {
          color: colors.text.secondary,
        },

        ...sx,
      }}
    >
      <DataGrid rows={rows} columns={columns} {...props} />
    </Box>
  );
};

export default ThemedDataGrid;